jQuery(function ($) {

  $('.date-picker').each(function () {

    const $picker   = $(this);
    const $calendar = $picker.find('.js-calendar');
    const $title    = $picker.find('.js-cal-title');

    const $startInp = $picker.find('.js-start');
    const $endInp   = $picker.find('.js-end');

    const mode      = $picker.data('mode');
    const drag      = $picker.data('drag') === true;
    const minDays   = parseInt($picker.data('min'), 10) || 1;
    const maxDays   = parseInt($picker.data('max'), 10) || 30;
    const disabled  = $picker.data('disabled') || [];

    let cursor    = new Date();
    let startDate = null;
    let endDate   = null;
    let dragging  = false;

    // --------------------------------------------------
    // Helpers
    // --------------------------------------------------
    function iso(date) {
      return date.toISOString().slice(0, 10);
    }

    function daysBetween(a, b) {
      return Math.round((b - a) / 86400000) + 1;
    }

    function updateInputs() {
      $startInp.val(startDate || '');
      $endInp.val(endDate || '');
    }

    // --------------------------------------------------
    // Render calendar
    // --------------------------------------------------
    function renderCalendar() {
      $calendar.empty();

      const year  = cursor.getFullYear();
      const month = cursor.getMonth();

      $title.text(
        cursor.toLocaleString('default', { month: 'long', year: 'numeric' })
      );

      const first = new Date(year, month, 1);
      const last  = new Date(year, month + 1, 0);

      for (let d = 1; d <= last.getDate(); d++) {
        const date = new Date(year, month, d);
        const key  = iso(date);

        const $day = $('<button>', {
          type: 'button',
          class: 'cal-day',
          text: d,
          'data-date': key
        });

        if (disabled.includes(key)) {
          $day.prop('disabled', true).addClass('is-disabled');
        }

        if (startDate === key) $day.addClass('is-start');
        if (endDate === key)   $day.addClass('is-end');

        if (startDate && endDate && key > startDate && key < endDate) {
          $day.addClass('is-range');
        }

        // -------------------------------
        // Mouse interactions
        // -------------------------------
        $day.on('mousedown', function () {
          if ($(this).is(':disabled')) return;

          startDate = key;
          endDate   = null;
          dragging  = true;
          renderCalendar();
        });

        $day.on('mouseenter', function () {
          if (!dragging || !drag || !startDate) return;
          if ($(this).is(':disabled')) return;

          endDate = key;

          const span = daysBetween(
            new Date(startDate),
            new Date(endDate)
          );

          if (span >= minDays && span <= maxDays) {
            renderCalendar();
          }
        });

        $day.on('mouseup', function () {
          if (!dragging) return;
          dragging = false;

          if (!endDate) endDate = startDate;
          updateInputs();
          renderCalendar();
        });

        $calendar.append($day);
      }
    }

    // --------------------------------------------------
    // Header navigation
    // --------------------------------------------------
    $picker.find('.cal-prev').on('click', function () {
      cursor.setMonth(cursor.getMonth() - 1);
      renderCalendar();
    });

    $picker.find('.cal-next').on('click', function () {
      cursor.setMonth(cursor.getMonth() + 1);
      renderCalendar();
    });

    // --------------------------------------------------
    // Presets
    // --------------------------------------------------
    $picker.find('.js-preset').on('click', function () {
      const type = $(this).data('type');
      const days = parseInt($(this).data('days'), 10);

      const today = new Date();
      startDate = iso(today);

      if (type === 'days' && days) {
        const end = new Date(today);
        end.setDate(end.getDate() + days - 1);
        endDate = iso(end);
      }

      updateInputs();
      renderCalendar();
    });

    // --------------------------------------------------
    // Actions
    // --------------------------------------------------
    $picker.find('.js-cancel').on('click', function () {
      startDate = null;
      endDate   = null;
      updateInputs();
      renderCalendar();
    });

    $picker.find('.js-apply').on('click', function () {
      $picker.trigger('dateSelected', [{
        start: startDate,
        end: endDate
      }]);
    });

    // --------------------------------------------------
    // Keyboard support (basic)
    // --------------------------------------------------
    $calendar.on('keydown', '.cal-day', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        $(this).trigger('mousedown').trigger('mouseup');
        e.preventDefault();
      }
    });

    // --------------------------------------------------
    // Init
    // --------------------------------------------------
    renderCalendar();

  });

});
